import { render } from "./CalendarDateIndicator.vue?vue&type=template&id=f708d182"
import script from "./CalendarDateIndicator.vue?vue&type=script&lang=js"
export * from "./CalendarDateIndicator.vue?vue&type=script&lang=js"

import exportComponent from "/home/renzon-carnes/htdocs/carnes.renzon.com/public/entregaspro/entregaspro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__